import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDeletePdfPages = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width={24} height={24} fill="#AA67FF" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.778 5.333h4.444M5.333 7.555h13.334m-1.482 0-.52 7.793c-.077 1.169-.116 1.753-.369 2.196-.222.39-.557.704-.961.9-.46.223-1.045.223-2.217.223h-2.236c-1.172 0-1.758 0-2.217-.223a2.22 2.22 0 0 1-.961-.9c-.253-.443-.292-1.027-.37-2.197l-.52-7.792m3.704 3.334v3.704m2.963-3.704v3.704"
    />
  </svg>
);
export default SvgDeletePdfPages;
